import type { ICartesianAxisCommonTheme } from '@visactor/vchart';

export const axisZ: ICartesianAxisCommonTheme = {
  label: {
    space: 0
  }
};
